module.exports = __webpack_public_path__ + "static/Fluke.f190a454.png";